import {
  GET_SITE_BY_ID_REQUEST,
  SET_CURRENT_SITE_ID,
} from '../../Constants/ActionTypes'

export function getSiteByID(payload) {
  return { type: GET_SITE_BY_ID_REQUEST, payload }
}

export function setCurrentSiteId(site_id) {
  return {
    type: SET_CURRENT_SITE_ID,
    payload: site_id,
  }
}
